// Shown when a real, valid session's account data (profile/company) fails
// to load after a retry — e.g. a slow/cold-starting DB connection. Distinct
// from AccountSetupPrompt ("Finish setting up your account"): that screen
// means "we successfully checked and you genuinely have no company yet";
// this one means "we couldn't check at all, here's an unambiguous retry."
// See AuthContext.tsx's hydrateFromSession for why this distinction exists.

import { useState } from "react";
import { useAuth } from "../AuthContext";

export function HydrationErrorScreen() {
  const { retryHydration } = useAuth();
  const [retrying, setRetrying] = useState(false);

  const onRetry = async () => {
    setRetrying(true);
    try {
      await retryHydration();
    } finally {
      setRetrying(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-lc-navy to-lc-blue-dark flex items-center justify-center p-5">
      <div className="w-full max-w-md bg-white rounded-xl p-8 shadow-2xl text-center">
        <div className="inline-flex w-12 h-12 rounded-xl bg-lc-blue-light text-lc-blue items-center justify-center mb-4">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M21 12a9 9 0 1 1-2.64-6.36" />
            <path d="M21 3v6h-6" />
          </svg>
        </div>
        <h1 className="text-xl font-extrabold text-lc-ink mb-1.5">Having trouble loading your account</h1>
        <p className="text-sm text-lc-mute leading-relaxed mb-6">
          This is usually a slow connection, not a problem with your account — your data is fine. Give it another try.
        </p>
        <button
          type="button"
          onClick={onRetry}
          disabled={retrying}
          className="w-full h-11 rounded-lc-md bg-gradient-to-br from-lc-blue to-lc-blue-dark text-white text-sm font-extrabold disabled:opacity-60"
        >
          {retrying ? "Retrying…" : "Try again"}
        </button>
      </div>
    </div>
  );
}
